import { create } from "zustand";

export const useSearchStore = create((set, get) => ({
    searchText: '',
    selectedCategory: 'all',
    
    // Set search text
    setSearchText: (text) => set({ searchText: text }),
    
    // Set selected category
    setSelectedCategory: (category) => set({ selectedCategory: category }),
    
    // Clear search
    clearSearch: () => set({ searchText: '', selectedCategory: 'all' }),
    
    // Update search params from URL
    updateFromUrl: (searchParams) => {
        const search = searchParams.get('search') || '';
        const category = searchParams.get('category') || 'all';
        set({ searchText: search, selectedCategory: category });
    },
    
    // Get search params for URL
    getSearchParams: () => {
        const state = get();
        const searchParams = new URLSearchParams();
        
        if (state.searchText.trim()) {
            searchParams.set('search', state.searchText.trim());
        }
        
        if (state.selectedCategory && state.selectedCategory !== 'all') {
            searchParams.set('category', state.selectedCategory);
        }
        
        return searchParams;
    }
})) 